<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block">
        <div class="head-block-title">
            <div class="row">
                <div class="col-md-8">
                    <span class="listHeaderText">Cancelled Bookings ({{bookingListData?.length}})</span>
                </div>
                <div class="col-md-4 d-flex" style="justify-content: flex-end;">
                    <export [showIconOnly]="false" [data]="selectedExportData"></export>
                </div>

            </div>
        </div>
        <div class="main-field">
            <div class="main-block-content">
                <div class="table-container">
                    <app-common-table-dark [columnDefs]="columnDefs" [data]="bookingListData" [rowStyles]="rowStyles"
                        [enableRowStyles]="true" (commonDropdownChange)="onCommonTableDropdownChange($event)"
                        (selectedRowsChange)="onSelectedRowsChange($event)" (rowAction)="onRowAction($event)">
                    </app-common-table-dark>
                </div>
            </div>
        </div>
    </div>

    <!-- Cancellation Details Modal -->
    <app-booking-cancellation-details-modal [isVisible]="showCancellationDetailsModal"
        [bookingId]="selectedBookingForDetails?.id" [bookingData]="selectedBookingForDetails"
        (closeModal)="closeCancellationDetailsModal()">
    </app-booking-cancellation-details-modal>
</div>
